module.exports = __webpack_public_path__ + "images/loaderOneGreena3ded0f65f9e1234fedf7a5290b94466.gif";